// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-2jl","delete":"styles_delete__1bfQ6","update":"styles_update__1cACx","add":"styles_add__ccsTF"};